<template functional>
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 42.983 42.983"
  >
    >
    <path
      d="M21.491,42.983A21.492,21.492,0,0,1,6.295,6.295,21.491,21.491,0,1,1,36.688,36.688,21.351,21.351,0,0,1,21.491,42.983Zm0-19.557a22.855,22.855,0,0,0-8.035,1.719,11.476,11.476,0,0,0-3.422,2.089A4.013,4.013,0,0,0,8.6,30.087a15.527,15.527,0,0,0,25.79,0,4.014,4.014,0,0,0-1.438-2.854,11.476,11.476,0,0,0-3.422-2.089A22.855,22.855,0,0,0,21.491,23.425Zm0-16.978A6.447,6.447,0,1,0,27.939,12.9,6.455,6.455,0,0,0,21.491,6.448Z"
      fill="#d6001b"
    />
  </svg>
</template>

<script>
export default {
  name: "IconProfileRed",

  props: {
    size: { type: [String, Number], default: "42.983px" },
  },
};
</script>
